import Vuex from 'vuex'
import Vue from 'vue'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    whiteNavTheme: false,
    footerFixed: false,
  },

  getters: {
    getNavState: state => {
      return state.whiteNavTheme
    },
    getFooterState: state => {
      return state.footerFixed
    },
  },

  mutations: {
    setWhiteNav(state) {
      state.whiteNavTheme = true
    },
    setDarkNav(state) {
      state.whiteNavTheme = false
    },

    setFixedFooter(state) {
      state.footerFixed = true
    },
    setDefaultFooter(state) {
      state.footerFixed = false
    },
  },

  actions: {
    setWhiteNav(context) {
      context.commit('setWhiteNav')
    },
    setDarkNav(context) {
      context.commit('setDarkNav')
    },

    setFixedFooter(context) {
      context.commit('setFixedFooter')
    },
    setDefaultFooter(context) {
      context.commit('setDefaultFooter')
    },
  },
})
